require("/media/dimaz/cb30f9b9-9bfc-4ad8-892d-858694071978/home/dimaz/www/yurproject/node_modules/bootstrap-sass/assets/javascripts/bootstrap/modal");